// extracted by mini-css-extract-plugin
module.exports = {"list":"Tabs_list__1kPmv","tabElement":"Tabs_tabElement__3leVm","tab":"Tabs_tab__3X84t","activeTab":"Tabs_activeTab__2UU9-","hasError":"Tabs_hasError__2j5zA"};